import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { change } from 'redux-form';
import Button from '../../../../components/form/Button';
import CroSubhead from '../../components/generalForm/CroSubhead';
import InfoMessage from '../../components/InfoMessage';
import InfoBannerForm from '../../components/forms/InfoBannerForm';
import { breadcrumbs } from '../../../../actions/appActions';
import {
    saveBanner,
    deleteBanner,
    activateBanner,
    deactivateBanner,
    saveBannerTemplate,
    deleteBannerTemplate,
    setDefaultTemplate,
    fetchActiveBanners,
    fetchBannerTemplates,
} from '../../CroActions';
import { styles } from '../../index';

const severityToVariant = (severity) => {
    if (severity === 'WARNING') return 'warning';
    if (severity === 'CRITICAL') return 'error';
    return null;
};

class InfoBanner extends Component {
    state = {
        banners: [],
        templates: [],
        defaultText: '',
    };

    async componentWillMount() {
        this.props.breadcrumbs([{ label: 'Správa upozornění' }]);
        await this.loadData();
    }

    loadData = async () => {
        const banners = await fetchActiveBanners(this.props.dispatch);
        const templates = await fetchBannerTemplates(this.props.dispatch);
        const sortedTemplates = (templates || []).sort((a, b) => {
            if (!a.deletable && b.deletable) return -1;
            if (a.deletable && !b.deletable) return 1;
            return 0;
        });
        const defaultTemplate = sortedTemplates.find(t => t.defaultTemplate);
        const defaultText = defaultTemplate ? defaultTemplate.text : '';
        this.setState({
            banners: banners || [],
            templates: sortedTemplates,
            defaultText,
        });
        if (defaultText) {
            this.props.dispatch(change('infoBannerForm', 'text', defaultText));
        }
    };

    onSubmit = async (data) => {
        await this.props.saveBanner(data);
        await this.loadData();
    };

    onSaveTemplate = async () => {
        const formValues = this.props.formValues;
        const text = formValues && formValues.text;
        if (!text) return;
        await this.props.saveTemplate({ text, deletable: true, defaultTemplate: false });
        await this.loadData();
    };

    onActivateBanner = async (id) => {
        await this.props.activateBanner(id);
        await this.loadData();
    };

    onDeactivateBanner = async (id) => {
        await this.props.deactivateBanner(id);
        await this.loadData();
    };

    onDeleteBanner = async (id) => {
        await this.props.deleteBanner(id);
        await this.loadData();
    };

    onDeleteTemplate = async (id) => {
        await this.props.deleteTemplate(id);
        await this.loadData();
    };

    onSetDefault = async (id) => {
        await this.props.setDefaultTemplate(id);
        await this.loadData();
    };

    onTemplateClick = (text) => {
        this.props.dispatch(change('infoBannerForm', 'text', text));
    };

    onEditBanner = (id) => {
        this.props.push(`/administrator/upozorneni/form/${id}`);
    };

    render() {
        const { banners, templates, defaultText } = this.state;

        const initialValues = {
            text: defaultText,
            severity: 'INFO',
            role_ROLE_ANONYMOUS: true,
            role_ROLE_PUBLIC: true,
            role_ROLE_OFFICIAL: true,
            role_ROLE_OVM: true,
            role_ROLE_LEGITIMATE: true,
            role_ROLE_INTERNAL_ADMIN: true,
            role_ROLE_INTERNAL_OFFICIAL_ADMIN: true,
            role_ROLE_INTERNAL_JUDGE: true,
        };

        return (
            <div>
                {/* === Active & Scheduled Banners === */}
                <div className="cro-form long-label">
                    <CroSubhead title="Aktivní a naplánovaná upozornění" />
                </div>
                {banners.length === 0 && (
                    <div style={{ padding: '10px 0', color: '#999' }}>Žádná aktivní upozornění</div>
                )}
                {banners.map((banner) => {
                    const variant = severityToVariant(banner.severity);
                    const cls = `infoMessage${variant ? ` infoMessage--${variant}` : ''}`;
                    return (
                        <p
                            key={banner.id}
                            className={cls}
                            style={{ display: 'flex', alignItems: 'center', opacity: banner.active ? 1 : 0.5, cursor: 'pointer' }}
                            onClick={() => this.onEditBanner(banner.id)}
                        >
                            <span style={{ fontWeight: 600 }}>{banner.text}</span>
                            <small style={{ whiteSpace: 'nowrap', marginLeft: 20 }}>
                                {banner.validFrom && `Od: ${new Date(banner.validFrom).toLocaleString('cs-CZ')}`}
                                {banner.validTo && ` Do: ${new Date(banner.validTo).toLocaleString('cs-CZ')}`}
                            </small>
                            <span style={{ flex: 1 }} />
                            <Button
                                type="button"
                                style={{ ...styles.buttons, marginLeft: 10, flexShrink: 0, backgroundColor: banner.active ? '#6c757d' : '#28a745' }}
                                label={banner.active ? 'Deaktivovat' : 'Aktivovat'}
                                onClick={(e) => { e.stopPropagation(); banner.active ? this.onDeactivateBanner(banner.id) : this.onActivateBanner(banner.id); }}
                            />
                            <Button
                                type="button"
                                style={{ ...styles.buttons, marginLeft: 10, flexShrink: 0 }}
                                label="Smazat"
                                onClick={(e) => { e.stopPropagation(); this.onDeleteBanner(banner.id); }}
                            />
                        </p>
                    );
                })}

                {/* === Create Banner Form === */}
                <div className="cro-form long-label" style={{ marginTop: 30 }}>
                    <CroSubhead title="Nové upozornění" />
                </div>
                <InfoBannerForm
                    initialValues={initialValues}
                    onSubmit={this.onSubmit}
                    onSaveTemplate={this.onSaveTemplate}
                    showSaveTemplate
                />

                {/* === Templates === */}
                <div className="cro-form long-label" style={{ marginTop: 30 }}>
                    <CroSubhead title="Šablony textů" />
                </div>
                {templates.map((template) => (
                    <div key={template.id} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                        <input
                            type="radio"
                            name="defaultTemplate"
                            checked={template.defaultTemplate}
                            onChange={() => this.onSetDefault(template.id)}
                            style={{ marginRight: 10, marginTop: 22, cursor: 'pointer', alignSelf: 'flex-start' }}
                        />
                        <div
                            style={{ flex: 1, cursor: 'pointer' }}
                            onClick={() => this.onTemplateClick(template.text)}
                        >
                            <InfoMessage>
                                {template.text}
                                {!template.deletable && (
                                    <span style={{ fontWeight: 'normal', marginLeft: 10, color: '#999' }}>
                                        — Systémová šablona
                                    </span>
                                )}
                            </InfoMessage>
                        </div>
                        {template.deletable && (
                            <Button
                                type="button"
                                style={{ ...styles.buttons, marginLeft: 10 }}
                                label="Smazat"
                                onClick={() => this.onDeleteTemplate(template.id)}
                            />
                        )}
                    </div>
                ))}
            </div>
        );
    }
}

export default connect(
    (state) => ({
        formValues: state.form.infoBannerForm && state.form.infoBannerForm.values,
    }),
    { breadcrumbs, saveBanner, deleteBanner, activateBanner, deactivateBanner, saveTemplate: saveBannerTemplate, deleteTemplate: deleteBannerTemplate, setDefaultTemplate, push }
)(InfoBanner);